// extracted by mini-css-extract-plugin
export var adCard = "_pc-8";
export var adCardBorder = "_pc-5";
export var arbiterButtonIcon = "_pc-p";
export var buttonIcon = "_pc-o";
export var container = "_pc-e";
export var copyButton = "_pc-m";
export var darkGrey = "_pc-u";
export var deliveryDate = "_pc-2";
export var divider = "_pc-n";
export var editModeWrapper = "_pc-7";
export var empty = "_pc-a";
export var errorIcon = "_pc-d";
export var filledCircle = "_pc-4";
export var fulfillmentFooter = "_pc-j";
export var grey = "_pc-s";
export var header = "_pc-i";
export var headerWrapper = "_pc-h";
export var highlighted = "_pc-6";
export var historyEntry = "_pc-3";
export var mobileColumn = "_pc-v";
export var mobileColumnReverse = "_pc-w";
export var orderDetailsContainer = "_pc-g";
export var orderMetadata = "_pc-l";
export var orderMetadataWrapper = "_pc-k";
export var packagesContainer = "_pc-b";
export var product = "_pc-y";
export var productImage = "_pc-z";
export var productInfo = "_pc-x";
export var productTitle = "_pc-10";
export var strikethrough = "_pc-t";
export var tinyText = "_pc-r";
export var title = "_pc-9";
export var trackerCard = "_pc-1";
export var trackerCardWrapper = "_pc-0";
export var trackingContainer = "_pc-f";
export var trackingTitle = "_pc-c";
export var xTinyText = "_pc-q";